import { useState } from "react";
import { DateTime } from "luxon";

import usePartProMessagesListing from "../../../data/usePartProMessagesListings";
import { IPartProConversation } from "../../../models/PartProMessage";
import { IPart } from "../../../models/Part";
import Card from "../Card/Card";
import LoadingWheel from "../LoadingWheel";
import PartProMessageChain from "../../partProMessaging/PartProMessageChain";
import formatDateTime from "../../../utils/formatDateTime";

export default function PartProPartMessages({ part }: { part: IPart }) {
  const { conversations } = usePartProMessagesListing({ part: part });
  const [chainOpen, setChainOpen] = useState(false);
  const [chosenConversation, setChosenConversation] = useState<IPartProConversation | undefined>();

  return (
    <Card title="PartPro Messages" bodyClassName="px-6 py-5">
      {
        conversations.isLoading ?
          <LoadingWheel /> :
          <>
            <PartProMessageChain open={chainOpen} setOpen={setChainOpen} conversation={chosenConversation} />
            <div className="flex-col">
              {
                conversations.data?.data?.length ?
                  conversations.data?.data.map((conversation) => <div key={conversation.id} className="mb-2 hover:bg-slate-200 hover:underline cursor-pointer" onClick={() => { setChosenConversation(conversation); setChainOpen(true); }}>
                    <span className="underline"><span className="font-bold">{conversation.buyerName ?? "Buyer"}</span> {formatDateTime(conversation.lastMessageAt, DateTime.DATETIME_SHORT)}</span>
                    <p className="">{conversation.lastMessageBody}</p>
                  </div>)
                  :
                  conversations.isError ? <div><p>Unable to retrieve messages</p></div> : <div><p>No Messages</p></div>
              }
            </div>
          </>
      }
    </Card>
  );
};
